import Nav from "../general/nav.jsx";
import { useTranslation } from "react-i18next";
import "./Accueil.css";
import { Link } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";

export default function Hero() {
  const { t } = useTranslation();
  const subtitleRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        subtitleRef.current,
        {
          y: -50,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="Accueil-Hero">
      <Nav />
      <div ref={subtitleRef} className="Accueil-Hero-content">
        <div className="Accueil-Hero-BackText">MAELCORP</div>
        <p>{t("hero.subtitle")}</p>
        <Link to="/contact" className="websiteBtn thin">
          {t("hero.button")}
        </Link>
      </div>
    </div>
  );
}
